import LoginForm from "../LoginForm/LoginForm";
import PasswordField from "../Password/Password";
import SearchBar from "../SearchBar/SearchBar";

import { useEffect } from "react";
import { useState } from "react";
import MyComponent from "../MyComponent";

export default function App() {
  const [clicks, setValues] = useState(() => {
    const savClicks = window.localStorage.getItem("m-click");
    return savClicks !== null ? JSON.parse(savClicks) : 0;
  });
  const handleLogin = log => {
    // Виконуємо необхідні операції з даними
    console.log(log);
    setValues(clicks + 1);
  };

  useEffect(() => {
    window.localStorage.setItem("m-click", JSON.stringify(clicks));
  }, [clicks]);

  return (
    <div>
      <>
        <MyComponent />
        <LoginForm onLogin={handleLogin} />
        <PasswordField />
        <SearchBar />
      </>
    </div>
  );
}
